import { render } from "./ReviewDelete.vue?vue&type=template&id=3b2c75db&ts=true"
import script from "./ReviewDelete.vue?vue&type=script&lang=ts"
export * from "./ReviewDelete.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__